export default __webpack_public_path__ + "static/media/masoneilan.4acbe489.png";